module.exports = __webpack_public_path__ + "static/media/gridLayout.b1d7f0ba.svg";